<template>
  <div class="macroscopic-detail">
    <div class="header">
      开始时间：
      <el-date-picker
          v-if="dictDataType === 'issue_macroscopic_cny_usd'"
          v-model="queryParams.startTime"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          style="width: 130px;margin-right: 24px;"
          :picker-options="pickerOptionsStart"
          placeholder="开始时间">
      </el-date-picker>
      <el-date-picker
          v-else
          v-model="queryParams.startTime"
          type="month"
          size="small"
          value-format="yyyy-MM"
          style="width: 130px;margin-right: 24px;"
          :picker-options="pickerOptionsStart"
          placeholder="开始时间">
      </el-date-picker>
      结束时间：
      <el-date-picker
          v-if="dictDataType === 'issue_macroscopic_cny_usd'"
          v-model="queryParams.endTime"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          style="width: 130px;margin-right: 24px;"
          :picker-options="pickerOptionsEnd"
          placeholder="结束时间">
      </el-date-picker>
      <el-date-picker
          v-else
          v-model="queryParams.endTime"
          type="month"
          size="small"
          value-format="yyyy-MM"
          style="width: 130px;margin-right: 24px;"
          :picker-options="pickerOptionsEnd"
          placeholder="结束时间">
      </el-date-picker>
      <button class="btn" @click="searchTime">搜索</button>
    </div>
    <div class="echarts" style="margin-top: 20px;padding-left: 10px">
      <div id="myChart" style="width: 900px;height:350px;"></div>
    </div>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="1000"
        style="width: 860px;margin:20px 40px 40px">
      <el-table-column
          v-if="dictDataType !== 'issue_macroscopic_cny_usd'"
          align="center"
          prop="time"
          label="月份">
      </el-table-column>
      <el-table-column
          v-if="dictDataType === 'issue_macroscopic_cny_usd'"
          align="center"
          prop="time"
          label="日期">
      </el-table-column>
      <el-table-column align="center" v-for="(item,index) in tabHead" :key="index">
        <template slot="header">
          <span v-if="unitList[index]">{{ item + '(' + unitList[index] + ')' }}</span>
          <span v-else>{{ item }}</span>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row[`price${index + 1}`] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {macroscopicList, macroscopicNoAuthList} from "@/api/macroscopic";

export default {
  name: "detail",
  props: [
    'dictDataType'
  ],
  data() {
    return {
      queryParams: {
        endTime: '',
        startTime: '',
        dictDataType: '',
      },
      tableData: [],
      unitList:[],
      tabHead: [],
      // 时间限制
      pickerOptionsStart: {
        // disabledDate: (time) => {
        //   if (this.queryParams.endTime) {
        //     return (
        //       time.getTime() >
        //         new Date(this.queryParams.endTime).getTime() -
        //           1 * 24 * 60 * 60 * 1000
        //     );
        //   }
        //   return time.getTime() < Date.now() - 8.64e7;
        // },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          return (
              time.getTime() <
              new Date(this.queryParams.startTime).getTime() +
              1 * 24 * 60 * 60 * 1000
          );
        },
      },
    }
  },
  watch: {
    dictDataType: {
      handler(val, oldVal) {
        this.queryParams['dictDataType'] = val || oldVal;
        this.queryParams['endTime'] = ''
        this.queryParams['startTime'] = ''
        this.getMapData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /**
     * 获取地图信息
     */
    getMapData() {
      const rLoading = this.openLoading();
      let option = {
        title: {
          text: "",
          padding: 10,
          textStyle: {
            fontWeight: 'bold',
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'top',
          padding: [20, 0, 0, 0],
          data: []
        },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [],
        dataZoom: [{
          type: 'inside',//图表下方的伸缩条
          show: true, //是否显示
          realtime: true, //拖动时，是否实时更新系列的视图
          start: 0, //伸缩条开始位置（1-100），可以随时更改
          end: 100, //伸缩条结束位置（1-100），可以随时更改
        }],
        grid: {
          x: 80,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
      this.tabHead = [];
      const fnc = this.queryParams['dictDataType'] === 'issue_macroscopic_present_price' ? macroscopicNoAuthList(this.queryParams) : macroscopicList(this.queryParams)
      fnc.then(res => {
        option['xAxis']['data'] = res.data['lineChart1']['dateList']
        this.tabHead = res.data['druidParamName']
        if (res.data['allDruidParamNamePrice'][0]) {
          option['title']['text'] = '单位:' + res.data['allDruidParamNamePrice'][0]
        } else {
          option['title'] = null;
        }
        this.unitList = res.data['unitList']
        this.tableData = res.data['data']
        res.data['allDruidParamName'].map((item, index) => {
          let obj = {
            name: item,
            type: "line",
            data: res.data[`lineChart${index + 1}`]['priceList'],
          };
          option.legend.data.push(item);
          option.series.push(obj);
        })
        this.drawChart(option);
        rLoading.close()
      })
    },
    /**
     * 选择时间
     */
    searchTime() {
      this.getMapData();
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      this.$echarts.init(document.getElementById('myChart')).dispose(); // 销毁实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    }
  }
}
</script>

<style scoped lang="less">
.macroscopic-detail {
  margin-bottom: 20px;
  width: 940px;
  //height: 687px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
  display: inline-block;
  vertical-align: middle;
  margin-left: 23px;

  .header {
    width: 940px;
    height: 60px;
    background: #F2F2F2;
    font-size: 12px;
    text-align: right;
    line-height: 60px;

    .btn {
      width: 64px;
      height: 27px;
      background: #D3131A;
      border-radius: 4px;
      display: inline-block;
      color: #fff;
      vertical-align: middle;
      line-height: 27px;
      text-align: center;
      margin-right: 40px;
      cursor: pointer;
      border:none;
    }
  }
}
</style>
